import React from 'react'
import { Box } from '@material-ui/core'

export const ConfirmDocumentsContainer: React.FC = ({ children }) => {
  return (
    <Box
      sx={{
        maxWidth: 520,
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'column',
        justifyContent: 'center'
      }}
    >
      {children}
    </Box>
  )
}
